import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { Dropdown } from '@bingads-webui-react/fabric-with-signal';

const dropdownStyles = {
  dropdown: { width: 160, marginLeft: '12px' },
  callout: { minWidth: 200 },
};

export const CurrencyDropdown = ({
  ariaLabel, currencies, selectedCurrency, onSelectCurrency,
}) => {
  const currencyOptions = _.map(currencies, currency => ({
    title: currency.text,
    selected: currency.Code === selectedCurrency,
    ...currency,
  }));

  const currentCurrencyTitle = _.find(currencyOptions, currency => currency.selected).title;

  return (
    <Dropdown
      options={currencyOptions}
      dropdownWidth="auto"
      styles={dropdownStyles}
      onChange={(e, val) => onSelectCurrency(_.get(val, 'key'))}
      aria-label={ariaLabel}
      title={currentCurrencyTitle}
    />
  );
};

CurrencyDropdown.propTypes = {
  currencies: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedCurrency: PropTypes.string.isRequired,
  onSelectCurrency: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};

CurrencyDropdown.defaultProps = {
  ariaLabel: '',
};
